import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/inversorFrequencia/actions';

import Form from './form';

function InversorFrequencia() {
  const redux = useSelector((state) => state.inversorFrequencia);

  const models = [{ label: 'WEG-CFW', value: 'WEG-CFW' }];

  const header = useMemo(
    () => [
      {
        id: 'codigoposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },
      {
        id: 'enderecoconversorinversorfrequencia',
        label: t('s.cadastro.preset.enderecopreset'),
        filter: { type: 'text' },
      },
      {
        id: 'idinversorfrequencia',
        label: t('s.menu.configuracao.inversoresfrequencias.enderecoRS485'),
        filter: { type: 'text' },
      },
      {
        id: 'modeloinversorfrequencia',
        label: t('s.menu.cadastro.veiculo.modelo'),
        formatted: (value) => models.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: models },
      },
      {
        id: 'portaconversorinversorfrequencia',
        label: t('s.configuracao.terminal.portaterminal'),
        filter: { type: 'text' },
      },
      // {
      //   id: 'modeloinversorfrequencia',
      //   label: t('s.menu.cadastro.veiculo.modelo'),
      //   formatted: (value) =>
      //     options.find((o) => o.label === value).value || '',
      //   filter: { type: 'select', models },
      // },
    ],
    []
    // [options]
  );

  const fieldlist = [
    'codigoposto',
    'enderecoconversorinversorfrequencia',
    'enderecoidinversorfrequencia',
    'idinversorfrequencia',
    'modeloinversorfrequencia',
    'portaconversorinversorfrequencia',
  ];

  const substituirHeader = {
    codigoposto: t('s.geral.postocomboio'),
    enderecoconversorinversorfrequencia: t('s.cadastro.preset.enderecopreset'),
    idinversorfrequencia: t(
      's.menu.configuracao.inversoresfrequencias.enderecoRS485'
    ),
    modeloinversorfrequencia: t('s.menu.cadastro.veiculo.modelo'),
    portaconversorinversorfrequencia: t(
      's.configuracao.terminal.portaterminal'
    ),
    enderecoidinversorfrequencia: t(
      's.menu.configuracao.inversoresfrequencias.enderecoRS485'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys={[
        'idposto',
        'enderecoconversorinversorfrequencia',
        'idinversorfrequencia',
      ]}
      detach="idinversorfrequencia"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'inversoresfrequencias',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Inversores de Frequência',
        })
      }
    />
  );
}

export default InversorFrequencia;
